import ApiClient from '../ApiClient';

class PolarisBulkActionsAPI extends ApiClient {
  constructor() {
    super('captain/bulk_actions', { accountScoped: true });
  }
}

export default new PolarisBulkActionsAPI();
